import { render, staticRenderFns } from "./WidgetCaseList.vue?vue&type=template&id=7967ea30&scoped=true&v-if=caseList%20%26%26%20caseList.length&"
import script from "./WidgetCaseList.vue?vue&type=script&lang=js&"
export * from "./WidgetCaseList.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCaseList.vue?vue&type=style&index=0&id=7967ea30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967ea30",
  null
  
)

export default component.exports